<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2021-06-29 22:55 -->
<template>
  <div class="row">
    <div class="col-lg-4 col-md-4">
      <div class="card mt-3">
        <div class="card-body">
          <h5 class="card-title">ANULAR VENTA</h5>
          <form @submit.prevent="save">
            <div class="mb-3">
              <label for="">Codigo de Venta</label>
              <input
                type="number"
                class="form-control"
                v-model="code"
                @change="afterSetCode"
              />
              <app-form-errors :member="errors.code"></app-form-errors>
            </div>
            <div class="mb-3">
              <label for="">
                Codigo de venta corregida
                <!-- <small class="text-muted">(opcional)</small> -->
              </label>
              <input
                type="number"
                class="form-control"
                v-model="new_code"
                @change="afterSetCode"
              />
              <app-form-errors :member="errors.new_code"></app-form-errors>
            </div>
            <div class="mb-3">
              <label for="">Sustento</label>
              <app-textarea v-model="reason"></app-textarea>
              <app-form-errors :member="errors.reason"></app-form-errors>
            </div>
            <div class="mb-3">
              <label for="">Nombre del responsable</label>
              <input
                type="text"
                name="personal_name"
                class="form-control"
                v-model="name"
              />
              <app-form-errors :member="errors.name"></app-form-errors>
            </div>
            <app-button-submit :disabled="errors" :loading="sending"
              >Anular</app-button-submit
            >
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-8" ref="elIframe"></div>
  </div>
</template>
<script>
import validator from "src/lt-module/utils/validator";
import { StoreService } from "../StoreService";
const formRules = {
  code: {
    presence: {
      allowEmpty: false,
      message: "Requieres indicar el codigo de venta"
    }
  },
  new_code: {
    presence: {
      allowEmpty: false,
      message: "Requieres indicar el nuevo codigo de venta"
    }
  },
  reason: {
    presence: { allowEmpty: false, message: "Requieres indicar un sustento" }
  },
  name: {
    presence: { allowEmpty: false, message: "Indica tu nombre" }
  }
};
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    code: null,
    new_code: null,
    reason: null,
    name: null,
    sending: false
  }),

  computed: {
    errors() {
      return validator(this.$data, formRules, { fullMessages: false });
    }
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    async save() {
      this.sending = true;
      let reason =
        `${this.name}; ${this.reason}` +
        (this.new_code ? `; nuevo codigo ${this.new_code}` : "");
      try {
        await StoreService.deleteSale(this.code, reason);
        window.alert(`La venta ${this.code} fue anulada`);
      } catch (e) {
        if (e.response.data.code == 1 || e.response.status == 401) {
          window.alert(e.response.data.message);
        } else {
          window.alert("Algo salio mal 🤡");
        }
      }
      this.sending = false;
    },
    afterSetCode() {
      this.$refs.elIframe.innerHTML = `<iframe src="${process.env.VUE_APP_API_URL}print/store/ticket2/${this.code}" frameborder="0" height="800" width="400"></iframe>`;
    }
  }
};
</script>

<style scoped></style>
